import 'ol/ol.css';
import FullScreen from 'ol/control/FullScreen';
import apply from 'ol-mapbox-style';
import Map from 'ol/Map';
import Hash from './hash';
import OGCVectorTile from 'ol/source/OGCVectorTile.js';
import VectorTileLayer from 'ol/layer/VectorTile.js';
import styleJson from './generic.json';
import MVT from 'ol/format/MVT.js';


/* map style and version selections */
/* v20 is current vector tile content released in 2020-06 */
/* v21 will be available in 2021 */
/* versioned styleUrl refers to Style document with a link to versioned TileJson document which has links to the Vector Tiles */
const tileVer = 'v20', styleVer = 'v20',
  styleName = 'hobby',
  tileMatrixSet = 'WGS84_Pseudo-Mercator',
  /* get your own api key at maanmittauslaitos.fi <https://www.maanmittauslaitos.fi/rajapinnat/api-avaimen-ohje> */
  apiKey = '7cd2ddae-9f2e-481c-99d0-404e7bc7a0b2',
  styleUrl = `https://avoin-karttakuva.maanmittauslaitos.fi/vectortiles/stylejson/${styleVer}/${styleName}.json?TileMatrixSet=${tileMatrixSet}&api-key=${apiKey}`;

/* maplibre compatible location url hash */
const hash = new Hash(),
  map = new Map({ target: 'map' });
hash.addTo(map);

/* fetch style and apply to map */
//fetch(styleUrl).then(r => r.json()).then(styleJson => {
  apply(
    map, styleJson).then(function (map) {
      map.addControl(new FullScreen());
      map.getLayers().insertAt(0,new VectorTileLayer({
        source: new OGCVectorTile({
          url: 'https://maps.gnosis.earth/ogcapi/collections/NaturalEarth:cultural:ne_10m_admin_0_countries/tiles/WebMercatorQuad',
          format: new MVT(),
        }),
        background: '#d1d1d1',
        style: {
          'stroke-width': 0.6,
          'stroke-color': '#8c8b8b',
          'fill-color': '#f7f7e9',
        },
      }));
    });
//});

